import React, { Component } from 'react';
import { 
  Grid,
  Row,
  Col,
  Button,
  Glyphicon
} from 'react-bootstrap';
import base from '../base';
import WorkoutStats from './WorkoutStats';
import CreateSetForm from './CreateSetForm';
import SetTable from './SetTable';
import UpdateSetModal from './UpdateSetModal';

class FreeWorkout extends Component {
  constructor(props) {
    super(props);

    this.createSet = this.createSet.bind(this);
    this.updateSet = this.updateSet.bind(this);
    this.deleteSet = this.deleteSet.bind(this);

    this.createExercise = this.createExercise.bind(this);

    this.deleteWorkout = this.deleteWorkout.bind(this);

    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleOkClick = this.handleOkClick.bind(this);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.calculateMountain = this.calculateMountain.bind(this);

    this.workoutNode = `/workouts/${this.props.uid}/${this.props.workoutKey}`;
    this.exerciseNode = `/exercises/${this.props.uid}`;

    this.state = {
      workout: {
        sets: {},
        total: 0
      },
      exercises: {},
      showModal: false,
      modalSet: {}
    };
  }

  componentWillMount() {
    // two way binding to workouts tree
    console.log(this.workoutNode);
    this.ref = base.syncState(this.workoutNode, {
      context: this,
      state: 'workout'
    });

    // two way binding to exercises tree
    this.exerciseRef = base.syncState(this.exerciseNode, {
      context: this,
      state: 'exercises'
    });
  }

  componentWillUnmount() {
    base.removeBinding(this.ref);
  }

  createSet(set) {
    const newSetRef = base.database().ref(`${this.workoutNode}/sets`).push();
    set.key = newSetRef.key;
    const sets = {...this.state.workout.sets};
    const updates = {};
    sets[set.key] = set;
    updates[`/sets`] = sets;
    const total = this.calculateMountain(sets);
    updates[`/total`] = total;
    base.database().ref(`${this.workoutNode}`).update(updates);
  }

  updateSet(set) {
    const workout = {...this.state.workout};
    workout.sets[set.key] = set;
    workout.total = this.calculateMountain(workout.sets);
    this.setState({
      workout: workout
    });
  }

  deleteSet(key) {
    const workout = {...this.state.workout};

    workout.sets[key] = null;
    workout.total = this.calculateMountain(workout.sets);

    this.setState({
      workout: workout
    });
  }

  createExercise(exercise) {
    const newExerciseRef = base.database().ref(this.exerciseNode).push();
    exercise.key = newExerciseRef.key;
    const exercises = {...this.state.exercises};
    exercises[exercise.key] = exercise;
    base.database().ref(`${this.exerciseNode}`).update(exercises);
    return exercise;
  }

  deleteWorkout() {
    base.database().ref(`${this.workoutNode}`).remove();
    this.context.router.push("/");
  }

  handleEditClick(key) {
    this.setState({
      showModal: true,
      modalSet: this.state.workout.sets[key]
    })
  }

  handleOkClick(set) {
    this.closeModal();
    this.updateSet(set);
  }

  openModal(key) {
    this.setState({
      showModal: true
    });
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  calculateMountain(sets) {
    if(sets) {
      return Object.keys(sets)
        .reduce((accumulator, key) => {
          const set = sets[key];
          if(set) {
            return accumulator + set.weight * set.reps;
          }
          return accumulator;
       }, 0); 
    }

    return 0;
  }

  render() {
    const { workout, exercises } = this.state;
    const sets = workout.sets || {};

    return (
      <Grid>
        <Row>
          <Col sm={12}>
            <WorkoutStats workout={workout}/>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <CreateSetForm 
              exercises={this.state.exercises} 
              createSet={this.createSet}
              createExercise={this.createExercise} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <SetTable 
              sets={sets} 
              exercises={exercises}
              onEditClick={this.handleEditClick} 
              deleteSet={this.deleteSet} 
            />
          </Col>
        </Row>
        <UpdateSetModal 
          show={this.state.showModal}
          set={this.state.modalSet}
          exercises={this.state.exercises}
          onOk={this.handleOkClick}
          onCancel={this.closeModal}
        />
        <Row>
          <Col sm={12}>
            <Button bsStyle="danger" onClick={this.deleteWorkout} block>
              <Glyphicon glyph="trash" />&nbsp;Delete Workout
            </Button>
          </Col>
        </Row>
      </Grid>
    );
  }
}

FreeWorkout.contextTypes = {
  router: React.PropTypes.object
}

FreeWorkout.propTypes = {
  uid: React.PropTypes.string.isRequired
}

export default FreeWorkout;



// WEBPACK FOOTER //
// ./src/components/FreeWorkout.jsx